document.addEventListener('DOMContentLoaded', () => {
  
  function hideUnavailableFilteredProducts() {
    // 1. Check the URL for active variant filters (e.g., ?filter.v.option.size=Large)
    const urlParams = new URLSearchParams(window.location.search);
    const activeFilters = [];

    urlParams.forEach((value, key) => {
      if (key.includes('filter.v.option')) {
        activeFilters.push(value);
      }
    });

    // If no variant filters are applied, exit the function
    if (activeFilters.length === 0) return;

    // 2. Select all product cards on the page. 
    // *Note: Update '.product-card' if Horizon uses a different class for its cards.
    const productCards = document.querySelectorAll('.product-grid__item');

    productCards.forEach(card => {
      const scriptTag = card.querySelector('[data-product-variants]');
      if (!scriptTag) return;

      try {
        const variants = JSON.parse(scriptTag.textContent);
        
        // 3. Find the specific variant that matches ALL currently active filters
        const matchingVariant = variants.find(variant => {
          return activeFilters.every(filterValue => variant.options.includes(filterValue));
        });

        // 4. If a matching variant exists but is sold out, hide the whole product card
        if (matchingVariant && !matchingVariant.available) {
          card.style.display = 'none';
        } else {
          card.style.display = ''; // Ensure it remains visible if in stock
        }
      } catch (error) {
        console.error("Error parsing variant data for filtering:", error);
      }
    });
  }

  // Run the function immediately when the page loads
  hideUnavailableFilteredProducts();

  // Run the function whenever Shopify's AJAX loads new products into the grid
  // *Note: Update '#product-grid' to match Horizon's main collection grid ID or class.
  const gridContainer = document.querySelector('.product-grid');
  
  if (gridContainer) {
    const observer = new MutationObserver(() => {
      hideUnavailableFilteredProducts();
    });
    // Watch for DOM changes inside the product grid
    observer.observe(gridContainer, { childList: true, subtree: true });
  }
});